export function equalsZeroUndefined(val) {
  return val === 0 || val === '0' || val === undefined;
}
